/* eslint-disable */
import { Component } from 'react';
import { Trans } from 'Helpers';
import { Modal, ModalBody, ModalFooter } from 'reactstrap'
import {Images} from 'Helpers';
import { SelectLeague, MoreComponent, SocialForm, NotificationComponents } from 'Components';


class HeaderModal extends Component {
  render() {
    const {isOpen, toggle} = this.props
    
    const MoreComponentProps = {
      onChangeDrawer: toggle,
      toggleDrawer: toggle,
      sendMessageToParent:toggle
    }
    let item = JSON.parse(localStorage.getItem('contestData'))

    return (
      <Modal  isOpen={isOpen} size='sm' centered className='header-modal-option'>
        <div onClick={toggle} className='close-modal-in'>
          <i className="icon-cancel"/>
        </div>
        <ModalBody>
            <div className='leage-head'>
              <div><i className='icon-league'></i> League</div>
              <div className='league-name'>{ item && item.league_name}</div>
            </div>
            <MoreComponent {...MoreComponentProps} />
        </ModalBody>
      </Modal>
    );
  }
}

export default HeaderModal;
